/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "dje",
        "0": "sot",
        "1": "nesër",
        "future": {
          "one": "pas {0} dite",
          "other": "pas {0} ditësh"
        },
        "past": {
          "one": "{0} ditë më parë",
          "other": "{0} ditë më parë"
        }
      },
      "day-narrow": {
        "-1": "dje",
        "0": "sot",
        "1": "nesër",
        "future": {
          "one": "pas {0} dite",
          "other": "pas {0} ditësh"
        },
        "past": {
          "one": "{0} ditë më parë",
          "other": "{0} ditë më parë"
        }
      },
      "day-short": {
        "-1": "dje",
        "0": "sot",
        "1": "nesër",
        "future": {
          "one": "pas {0} dite",
          "other": "pas {0} ditësh"
        },
        "past": {
          "one": "{0} ditë më parë",
          "other": "{0} ditë më parë"
        }
      },
      "hour": {
        "0": "këtë orë",
        "future": {
          "one": "pas {0} ore",
          "other": "pas {0} orësh"
        },
        "past": {
          "one": "{0} orë më parë",
          "other": "{0} orë më parë"
        }
      },
      "hour-narrow": {
        "0": "këtë orë",
        "future": {
          "one": "pas {0} ore",
          "other": "pas {0} orësh"
        },
        "past": {
          "one": "{0} orë më parë",
          "other": "{0} orë më parë"
        }
      },
      "hour-short": {
        "0": "këtë orë",
        "future": {
          "one": "pas {0} ore",
          "other": "pas {0} orësh"
        },
        "past": {
          "one": "{0} orë më parë",
          "other": "{0} orë më parë"
        }
      },
      "minute": {
        "0": "këtë minutë",
        "future": {
          "one": "pas {0} minute",
          "other": "pas {0} minutash"
        },
        "past": {
          "one": "{0} minutë më parë",
          "other": "{0} minuta më parë"
        }
      },
      "minute-narrow": {
        "0": "këtë minutë",
        "future": {
          "one": "pas {0} min",
          "other": "pas {0} min"
        },
        "past": {
          "one": "{0} min më parë",
          "other": "{0} min më parë"
        }
      },
      "minute-short": {
        "0": "këtë minutë",
        "future": {
          "one": "pas {0} min",
          "other": "pas {0} min"
        },
        "past": {
          "one": "{0} min më parë",
          "other": "{0} min më parë"
        }
      },
      "month": {
        "-1": "muajin e kaluar",
        "0": "këtë muaj",
        "1": "muajin e ardhshëm",
        "future": {
          "one": "pas {0} muaji",
          "other": "pas {0} muajsh"
        },
        "past": {
          "one": "{0} muaj më parë",
          "other": "{0} muaj më parë"
        }
      },
      "month-narrow": {
        "-1": "muajin e kaluar",
        "0": "këtë muaj",
        "1": "muajin e ardhshëm",
        "future": {
          "one": "pas {0} muaji",
          "other": "pas {0} muajsh"
        },
        "past": {
          "one": "{0} muaj më parë",
          "other": "{0} muaj më parë"
        }
      },
      "month-short": {
        "-1": "muajin e kaluar",
        "0": "këtë muaj",
        "1": "muajin e ardhshëm",
        "future": {
          "one": "pas {0} muaji",
          "other": "pas {0} muajsh"
        },
        "past": {
          "one": "{0} muaj më parë",
          "other": "{0} muaj më parë"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "tremujorin e kaluar",
        "0": "këtë tremujor",
        "1": "tremujorin e ardhshëm",
        "future": {
          "one": "pas {0} tremujori",
          "other": "pas {0} tremujorësh"
        },
        "past": {
          "one": "{0} tremujor më parë",
          "other": "{0} tremujorë më parë"
        }
      },
      "quarter-narrow": {
        "-1": "tremujorin e kaluar",
        "0": "këtë tremujor",
        "1": "tremujorin e ardhshëm",
        "future": {
          "one": "pas {0} tremujori",
          "other": "pas {0} tremujorësh"
        },
        "past": {
          "one": "{0} tremujor më parë",
          "other": "{0} tremujorë më parë"
        }
      },
      "quarter-short": {
        "-1": "tremujorin e kaluar",
        "0": "këtë tremujor",
        "1": "tremujorin e ardhshëm",
        "future": {
          "one": "pas {0} tremujori",
          "other": "pas {0} tremujorësh"
        },
        "past": {
          "one": "{0} tremujor më parë",
          "other": "{0} tremujorë më parë"
        }
      },
      "second": {
        "0": "tani",
        "future": {
          "one": "pas {0} sekonde",
          "other": "pas {0} sekondash"
        },
        "past": {
          "one": "{0} sekondë më parë",
          "other": "{0} sekonda më parë"
        }
      },
      "second-narrow": {
        "0": "tani",
        "future": {
          "one": "pas {0} sek",
          "other": "pas {0} sek"
        },
        "past": {
          "one": "{0} sek më parë",
          "other": "{0} sek më parë"
        }
      },
      "second-short": {
        "0": "tani",
        "future": {
          "one": "pas {0} sek",
          "other": "pas {0} sek"
        },
        "past": {
          "one": "{0} sek më parë",
          "other": "{0} sek më parë"
        }
      },
      "week": {
        "-1": "javën e kaluar",
        "0": "këtë javë",
        "1": "javën e ardhshme",
        "future": {
          "one": "pas {0} jave",
          "other": "pas {0} javësh"
        },
        "past": {
          "one": "{0} javë më parë",
          "other": "{0} javë më parë"
        }
      },
      "week-narrow": {
        "-1": "javën e kaluar",
        "0": "këtë javë",
        "1": "javën e ardhshme",
        "future": {
          "one": "pas {0} jave",
          "other": "pas {0} javësh"
        },
        "past": {
          "one": "{0} javë më parë",
          "other": "{0} javë më parë"
        }
      },
      "week-short": {
        "-1": "javën e kaluar",
        "0": "këtë javë",
        "1": "javën e ardhshme",
        "future": {
          "one": "pas {0} jave",
          "other": "pas {0} javësh"
        },
        "past": {
          "one": "{0} javë më parë",
          "other": "{0} javë më parë"
        }
      },
      "year": {
        "-1": "vjet",
        "0": "sivjet",
        "1": "mot",
        "future": {
          "one": "pas {0} viti",
          "other": "pas {0} vjetësh"
        },
        "past": {
          "one": "{0} vit më parë",
          "other": "{0} vjet më parë"
        }
      },
      "year-narrow": {
        "-1": "vitin e kaluar",
        "0": "këtë vit",
        "1": "vitin e ardhshëm",
        "future": {
          "one": "pas {0} viti",
          "other": "pas {0} vjetësh"
        },
        "past": {
          "one": "{0} vit më parë",
          "other": "{0} vjet më parë"
        }
      },
      "year-short": {
        "-1": "vitin e kaluar",
        "0": "këtë vit",
        "1": "vitin e ardhshëm",
        "future": {
          "one": "pas {0} viti",
          "other": "pas {0} vjetësh"
        },
        "past": {
          "one": "{0} vit më parë",
          "other": "{0} vjet më parë"
        }
      }
    },
    "locale": "sq-XK"
  });
}